import gql from 'graphql-tag';

export default gql`
  mutation removeCreditCard($paymentAccountId: UUID!, $id: String!) {
    payments {
      removeCreditCard(paymentAccountId: $paymentAccountId, id: $id)
    }
  }
`;
